import React, { useEffect, useState } from 'react';
import taskValues from './TaskValues';
import { fetchProjectTaskFileBlob } from '../../services/api';
import { useLanguage } from '../../i18n/LanguageContext';

const MAX_VALUES = 4;
const cache = new Map(); // id file -> object URL (le immagini richiedono il token: si scaricano come blob)

/** Anteprima di un'immagine allegata (scaricata con l'autenticazione). */
function AuthImage({ taskId, file, alt }) {
  const [url, setUrl] = useState(cache.get(file.id) || null);
  useEffect(() => {
    if (cache.has(file.id)) {
      setUrl(cache.get(file.id));
      return undefined;
    }
    let cancelled = false;
    fetchProjectTaskFileBlob(taskId, file.id)
      .then((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        cache.set(file.id, objectUrl);
        if (!cancelled) setUrl(objectUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [taskId, file.id]);
  return url ? <img className="pg-img" src={url} alt={alt} loading="lazy" /> : <span className="pg-img pg-img-loading" aria-hidden="true" />;
}

/**
 * Vista galleria: schede con la prima immagine di una colonna "file" come
 * copertina (se scelta), il titolo e alcuni valori.
 */
function ProjectGallery({ tasks, allTasks, columns, users, coverColumn, color, onOpen, onAdd }) {
  const { t } = useLanguage();
  const valueColumns = columns.filter((c) => c.type !== 'title');

  const coverFile = (task) => {
    if (!coverColumn) return null;
    const files = task.data[String(coverColumn.id)];
    return (Array.isArray(files) ? files : []).find((f) => (f.mime || '').startsWith('image/')) || null;
  };

  return (
    <div className="pg-grid">
      {tasks.map((task) => {
        const file = coverFile(task);
        return (
          <div key={task.id} className="pg-card" role="button" tabIndex={0} onClick={() => onOpen(task)} onKeyDown={(e) => e.key === 'Enter' && onOpen(task)}>
            {coverColumn && (
              <div className="pg-cover" style={file ? undefined : { background: `color-mix(in srgb, ${color} 14%, var(--subtle-bg))` }}>
                {file && <AuthImage taskId={task.id} file={file} alt={task.title} />}
              </div>
            )}
            <div className="pg-body">
              <div className="pg-title">{task.title || t('projectDetail.untitled')}</div>
              <div className="pg-values">{taskValues(task, valueColumns, { users, allTasks, max: MAX_VALUES })}</div>
            </div>
          </div>
        );
      })}
      <button type="button" className="pg-card pg-add" onClick={() => onAdd()}>
        <span aria-hidden="true">+</span> {t('projectDetail.newTask')}
      </button>
    </div>
  );
}

export default ProjectGallery;
